<template>
  <Modal title="变更active状态" v-model="visible" width="600" class="change-modal" :mask-closable="false" :loading="submitLoading" @on-ok="handleSubmit">
    <Form ref="formRef" :model="formData" :rules="formRules" :label-width="120">
      <FormItem label="IFA姓名" prop="name">
        <Input v-model="formData.name" disabled />
      </FormItem>
      <FormItem label="考核期" prop="assessmentPeriod">
        <Input v-model="formData.assessmentPeriodDisplay" disabled />
      </FormItem>
      <FormItem label="当前状态" prop="currentStatus">
        <Tag :color="formData.activeStatus === 1 ? 'success' : 'error'" style="margin-right: 8px">
          {{ formData.activeStatus === 1 ? '已达标' : '未达标' }}
        </Tag>
      </FormItem>
      <FormItem label="变更后状态" prop="newStatus">
        <RadioGroup v-model="formData.newStatus">
          <Radio :value="1">已达标</Radio>
          <Radio :value="0">未达标</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem label="变更原因" prop="reason">
        <Input v-model="formData.reason" type="textarea" :rows="4" placeholder="请输入变更原因" maxlength="200" show-word-limit></Input>
      </FormItem>
    </Form>
  </Modal>
</template>

<script>
export default {
  name: 'ChangeModal',
  data() {
    return {
      visible: false,
      submitLoading: false,
      formData: {
        id: '',
        name: '',
        teamName: '',
        startDate: '',
        endDate: '',
        assessmentPeriod: '',
        assessmentPeriodDisplay: '',
        activeStatus: '',
        newStatus: '',
        reason: ''
      },
      formRules: {
        newStatus: [{ required: true, message: '请选择变更后的状态', trigger: 'change' }],
        reason: [{ required: true, message: '请输入变更原因', trigger: 'blur' }]
      }
    };
  },
  methods: {
    /**
     * 打开变更弹窗
     * @param {Object} row - 行数据
     */
    open(row) {
      console.log('[ChangeModal] 打开变更', row);
      this.formData = {
        id: row.id,
        name: row.name,
        teamName: row.teamName,
        startDate: row.startDate,
        endDate: row.endDate,
        assessmentPeriod: `${row.startDate}_${row.endDate}`,
        assessmentPeriodDisplay: `${row.startDate || ''}至${row.endDate || ''}`,
        activeStatus: row.activeStatus,
        newStatus: '',
        reason: ''
      };
      this.visible = true;

      // 重置表单验证
      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.resetFields();
        }
      });
    },

    /**
     * 提交表单
     */
    handleSubmit() {
      if (this.submitLoading) return;

      this.$refs.formRef.validate(valid => {
        if (valid) {
          this.doSubmit();
        } else {
          this.visible = false;
          this.$nextTick(() => {
            this.visible = true;
          });
        }
      });
    },

    /**
     * 执行提交
     */
    doSubmit() {
      this.submitLoading = true;

      const submitData = {
        id: this.formData.id,
        activeStatus: this.formData.newStatus,
        reason: this.formData.reason,
        startDate: this.formData.startDate,
        endDate: this.formData.endDate
      };

      console.log('[ChangeModal] 提交数据', submitData);

      this.$http({
        url: '/buz/activeQuery/changeStatus',
        type: 'POST',
        data: submitData
      })
        .then(res => {
          this.submitLoading = false;
          if (res.httpCode === 1) {
            this.$notice.msg('操作成功');
            this.visible = false;
            this.$emit('success');
          } else {
            this.$notice.msg(res.msg || '操作失败');
          }
        })
        .catch(err => {
          this.submitLoading = false;
          console.error('[ChangeModal] 操作失败', err);
          this.$notice.msg('操作失败');
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.change-modal {
  /deep/.ivu-modal-body {
    padding: 30px 40px;
  }

  /deep/.ivu-form-item-label {
    font-weight: 500;
  }

  /deep/.ivu-input[disabled] {
    background-color: #f5f7fa;
    color: #909399;
  }
}
</style>
